import { Siren, TriangleAlert } from 'lucide-react'
import { FadeIn } from '../../ui/FadeIn'
import { GlassCard } from '../../ui/GlassCard'
import { useLanguage } from '../../../contexts/LanguageContext'

export function IncidentsSOSModule() {
  const { t } = useLanguage()

  return (
    <FadeIn className="h-full">
      <GlassCard className="h-full">
        <div className="flex items-start justify-between gap-4">
          <div>
            <div className="text-sm font-semibold tracking-tight">{t('product.incidents.title')}</div>
            <div className="mt-1 text-xs text-white/65">
              {t('product.incidents.desc')}
            </div>
          </div>
          <div className="flex items-center gap-2">
            <span className="grid size-10 place-items-center rounded-xl bg-white/10 border border-white/10">
              <Siren className="size-5 text-nexus-blue" />
            </span>
            <span className="grid size-10 place-items-center rounded-xl bg-white/10 border border-white/10">
              <TriangleAlert className="size-5 text-nexus-cyan" />
            </span>
          </div>
        </div>

        <div className="mt-5">
          <div className="rounded-2xl border border-white/10 bg-gradient-to-r from-nexus-blue/18 via-white/6 to-nexus-cyan/12 p-4">
            <div className="text-xs text-white/65">{t('product.incidents.latency')}</div>
            <div className="mt-1 text-2xl font-semibold tracking-tight">
              10<span className="text-white/60">ms</span>
            </div>
            <div className="mt-2 text-xs text-white/70">
              {t('product.incidents.notification')}
            </div>
          </div>

          <div className="mt-3 grid gap-2 text-sm text-white/70 sm:grid-cols-2">
            <div className="rounded-xl border border-white/10 bg-white/6 px-3 py-2">
              {t('product.incidents.evidence')}
            </div>
            <div className="rounded-xl border border-white/10 bg-white/6 px-3 py-2">
              {t('product.incidents.escalation')}
            </div>
          </div>
        </div>
      </GlassCard>
    </FadeIn>
  )
}


